import {templates} from 'features/beersManager/typescript';
import {postGeneratorSteps} from 'features/postGenerator/typescript';

export const getDefaultBackground = (template: templates, step?: postGeneratorSteps) => {
  const templateBackgrounds = {
    [templates.Standard]: 'images/template-classic-1.png',
    [templates.Standard2]: 'images/template-modern.png',
  };

  if (step === postGeneratorSteps.postType) return 'images/post-default-sm.png';

  return templateBackgrounds[template];
};
